import { module } from 'angular';
import { ARMORY_PLATFORM_STATES } from './armory.states';
import { TERRAFORM_MODULE } from './terraform/terraform.module';

export const ARMORY_MODULE = 'armory.platform';
module(ARMORY_MODULE, [
  ARMORY_PLATFORM_STATES,
  TERRAFORM_MODULE,
]);
